module.exports = __webpack_public_path__ + "static/media/email_sent_icon.034a3d29.svg";